import { get } from 'lodash-es';
import * as statusBar from '../constants/statusBar';
import { getFrame } from './project';
import { getCurrentScreen } from './screen';
export function getStatusBarUnderlayHeight(state) {
    return state.project.config.statusBar.screenNeedsMovedDown
        ? getStatusBarHeight(state)
        : 0;
}
export function getStatusBarUnderlayColor(state) {
    var screen = getCurrentScreen(state);
    return screen.colorSamples.statusBar;
}
export function getStatusBarTrimHeight(state) {
    return state.project.config.statusBar.trimHeight;
}
export function bodyNeedsDeviceHeight(state) {
    return get(state, 'project.config.statusBar.bodyNeedsDeviceHeight', false);
}
export function getStatusBarHeight(state) {
    return statusBar.getHeight(getFrame(state));
}
